import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Flex, Image, LoadingOverlay, Paper, Stack, Text, Textarea, Title } from "@mantine/core";

import { useRequestTenantCreation } from "../../hooks/clients";

export interface RequestTenantCreationProps {}
export const RequestTenantCreation = ({}: RequestTenantCreationProps) => {
    const { t } = useTranslation(["common"]);

    const [isSent, setIsSent] = useState(false);

    const [message, setMessage] = useState("");

    const { requestTenantCreation, isRequestingTenantCreation } = useRequestTenantCreation();

    const handleSend = useCallback(async () => {
        await requestTenantCreation(message);
        setIsSent(true);
    }, [message, requestTenantCreation]);

    return (
        <Flex gap="xl" justify="center" align="flex-start">
            <Box>
                <Image src="/images/person-looking.svg" height="240px" width="auto" my="xl" />
            </Box>
            <Paper pos="relative" p={36} radius={12} miw="320px" maw="420px">
                <LoadingOverlay visible={isRequestingTenantCreation} />
                <Stack>
                    <Title order={3}>
                        {isSent ? t("requesttenantcreation_title_sent") : t("requesttenantcreation_title")}
                    </Title>
                    {isSent ? (
                        <Text>{t("requesttenantcreation_text_sent")}</Text>
                    ) : (
                        <>
                            <Box>
                                <Text weight={500} mb="6px">
                                    {t("requesttenantcreation_text1")}
                                </Text>
                                <Text weight={200} color="gray">
                                    {t("requesttenantcreation_text2")}
                                </Text>
                            </Box>
                            <Box mt="xl">
                                <Textarea
                                    placeholder={t("message")}
                                    value={message}
                                    onChange={(event) => setMessage(event?.target?.value)}
                                />
                            </Box>
                            <Button radius="xl" onClick={handleSend}>
                                {t("requesttenantcreation_send")}
                            </Button>
                        </>
                    )}
                </Stack>
            </Paper>
        </Flex>
    );
};
